import { computed, ref, watch } from '@vue/composition-api'
import MobileOrderCard from '@/components/MobileOrderCard/MobileOrderCard'
import useForm from '@/compositions/useForm'
import useRequest from '@/compositions/useRequest'

import { required, requiredIf } from '@/utils/validations'

export default {
  components: { MobileOrderCard },
  setup(props, context) {
    const { $store } = context.root

    const ordersLoading = ref(true)
    const addOrderType = ref(null)
    const addFormOpened = ref(false)
    const trackInstances = ref([])
    const nextStepOpened = ref(false)

    const orders = computed(() => $store.state.driver.works)
    const btnText = computed(() => (addOrderType.value === 'order' ? 'заказ' : 'трек'))

    const {
      validate, formData, getData, $errors, reset,
    } = useForm({
      reactive: true,
      fields: {
        orderId: { default: '', validations: { required } },
        instanceId: { default: '', validations: { required: requiredIf(() => nextStepOpened.value) } },
      },
    })

    const cancelAddForm = () => {
      addFormOpened.value = false
      nextStepOpened.value = false
      reset()
    }

    const { makeRequest, loading } = useRequest({
      context,
      successMessage: 'Заказ добавлен!',
      successCallback: () => cancelAddForm(),
      failCallback: () => cancelAddForm(),
      request: data => $store.dispatch('driver/setOrder', data),
    })

    const { makeRequest: getTrackRequest, loading: loadingInstances } = useRequest({
      context,
      failCallback: () => cancelAddForm(),
      request: ({ id }) => $store.dispatch('driver/getTrack', { id }),
    })

    const showNextStep = async () => {
      nextStepOpened.value = true
      const track = await getTrackRequest({ id: formData.orderId.value })
      trackInstances.value = track.trackerInstances.map(i => i.instance)
    }

    const submitAddForm = async () => {
      if (!validate()) return
      const data = getData()
      if (addOrderType.value === 'track' && !nextStepOpened.value) {
        await showNextStep()
        return
      }
      const type = addOrderType.value === 'track' ? 'tracker' : 'order'
      await makeRequest({ id: data.orderId, type, instanceId: data.instanceId })
    }

    const getBtnText = () => {
      if (addOrderType.value === 'track' && !nextStepOpened.value) return 'Далее'
      return `Добавить ${btnText.value}`
    }

    watch(() => orders.value, () => {
      if (orders.value) ordersLoading.value = false
    }, { immediate: true })

    return {
      orders,
      loading,
      formData,
      $errors,
      ordersLoading,
      loadingInstances,
      addOrderType,
      addFormOpened,
      nextStepOpened,
      trackInstances,
      btnText,
      showNextStep,
      submitAddForm,
      cancelAddForm,
      getBtnText,
    }
  },
}
